import { ReactNode } from 'react';

import { Button, Spinner } from '@iwoca/orion';

import { useGetContext } from '../../api/lending/lapiHooks';
import { ErrorBoundary } from '../../AppWrapper';
import { buildQueryString } from '../../Buyer/utils/queryParams';
import iwocaPayLogo from '../../components/svg/iwocaPayLogo.svg';

export const PageNotFound = () => {
  const {
    context: { isLoggedIn, isLoading },
  } = useGetContext();

  const DashboardButton = () => {
    const Shell = ({ children }: { children: ReactNode }) => {
      return (
        <div className="mt-2xl flex h-[50px] items-center justify-center">
          {children}
        </div>
      );
    };

    if (isLoading) {
      return (
        <Shell>
          <Spinner />
        </Shell>
      );
    }

    return (
      <a href={`/account/${buildQueryString()}`} className="no-underline">
        <Shell>
          <Button>
            <>{isLoggedIn ? 'Go to dashboard' : 'Go to login'}</>
          </Button>
        </Shell>
      </a>
    );
  };

  return (
    <ErrorBoundary>
      <a href={`/account/${buildQueryString()}`}>
        <img
          src={iwocaPayLogo}
          alt="iwocaPay logo"
          aria-hidden="true"
          className="fixed left-l top-l"
        />
      </a>
      <div className="flex min-h-screen items-center justify-center">
        <div className="mt-[-80px] max-w-md">
          <h1 className="mt-0 text-5xl">404</h1>
          <p className="text-l font-reg">
            Oops! Looks like we couldn’t find what you were looking for.
          </p>
          <p className="text-m font-reg text-structure-20">
            Please check the URL or go back and try again.
          </p>

          <DashboardButton />
        </div>
      </div>
    </ErrorBoundary>
  );
};
